import { Chart } from 'chart.js';
import { controllers } from '../../controllers/controller';
var statisticsChart = function () {
    var canvas1 = document.querySelector('#myChart-1');
    var ctx1 = canvas1.getContext('2d');
    var totalWordCount = new Chart(ctx1, {
        type: 'line',
        data: {
            labels: ['', '', '...', '', '', 'Вчера', 'Сегодня'],
            datasets: [
                {
                    backgroundColor: [
                        'rgba(4, 124, 148, 0.3)'
                    ],
                    borderColor: [
                        'rgba(32, 164, 180, 1)',
                        'rgba(32, 164, 180, 1)',
                        'rgba(32, 164, 180, 1)',
                        'rgba(32, 164, 180, 1)',
                        'rgba(32, 164, 180, 1)',
                        'rgba(32, 164, 180, 1)',
                        'rgba(32, 164, 180, 1)'
                    ],
                    borderWidth: 3,
                    label: 'Всего слов',
                    data: [10, 25, 30, 50, 61, 70, 85],
                },
            ],
        },
        options: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Общеее количество изученных слов',
                position: 'top',
                fontSize: 16,
                padding: 10
            },
            scales: {
                yAxes: [
                    {
                        stacked: true,
                    },
                ],
            },
        },
    });
    var canvas2 = document.querySelector('#myChart-2');
    var ctx2 = canvas2.getContext('2d');
    var wordsByDay = new Chart(ctx2, {
        type: 'bar',
        data: {
            labels: ['', '', '...', '', 'Вчера', 'Сегодня'],
            datasets: [{
                    label: 'Количество слов',
                    data: [30, 35, 28, 20, 31, 40],
                    backgroundColor: [
                        'rgba(177, 207, 211, 0.6)',
                        'rgba(152, 212, 228, 0.6)',
                        'rgba(32, 164, 180, 0.6)',
                        'rgba(80, 155, 166, 0.6)',
                        'rgba(4, 124, 148, 0.6)',
                        'rgba(47, 99, 102, 0.6)'
                    ],
                    borderColor: [
                        'rgba(177, 207, 211, 1)',
                        'rgba(152, 212, 228, 1)',
                        'rgba(32, 164, 180, 1)',
                        'rgba(80, 155, 166, 1)',
                        'rgba(4, 124, 148, 1)',
                        'rgba(47, 99, 102, 1)'
                    ],
                    borderWidth: 1
                }]
        },
        options: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: 'Количество новых слов за каждый день изучения',
                position: 'top',
                fontSize: 16,
                padding: 10
            },
            scales: {
                yAxes: [{
                        ticks: {
                            min: 0,
                            max: 45
                        }
                    }]
            }
        }
    });
};
/*скрывает статистику для неавторизованных пользователей*/
function showStatisticsModal() {
    var statisticsNonAuthorisedModal = document.querySelector('#statistics-non-authorised-modal');
    if (controllers.isUserSignIn == true) {
        statisticsNonAuthorisedModal.classList.add('visually-hidden');
        updateStatisticsAG();
    }
    else {
        statisticsNonAuthorisedModal.classList.remove('visually-hidden');
    }
}
/*обновляет блок статистики для аудиовызова*/
var statisticsAGWordsHTML = document.querySelector('#statistics-audio-game-new-words');
var statisticsAGWinrateHTML = document.querySelector('#statistics-audio-game-winrate');
var statisticsAGWinstreakHtml = document.querySelector('#statistics-audio-game-winstreak');
function updateStatisticsAG() {
    if (localStorage.getItem('statisticsAG')) {
        var statisticsAG = JSON.parse(localStorage.getItem('statisticsAG'));
        statisticsAGWordsHTML.innerHTML = String(statisticsAG.newWords);
        statisticsAGWinrateHTML.innerHTML = "".concat(String(statisticsAG.winRate), "%");
        statisticsAGWinstreakHtml.innerHTML = String(statisticsAG.longestWinStreak);
    }
}
var statistics = function () {
    showStatisticsModal();
    document.querySelector('#nav-statistics').addEventListener('click', showStatisticsModal);
    document.querySelector('#nav-statistics-adaptive').addEventListener('click', showStatisticsModal);
};
export { statistics, statisticsChart, showStatisticsModal };
